import { z } from 'zod'
import { REQUIRED_MESSAGE } from '@Const/error-messages'
import { stringSizeMaxMessage } from '@Entities/schemas/work/error-messages'
import { IPIValidator } from '@App/helpers/validate'
import { FormFields } from '@App/forms/v2/common/form-field'
import { FormFieldTypes } from '@App/enum/form-field-types'
import populateSchema from '@App/forms/v2/helpers/populate-schema'

const publisherNameKey = 'publisherName'
const publisherNameLabel = 'Publisher Name'
const administratorNameLabel = 'Administrator Name'
const ipiNumberKey = 'ipiNumber'
const ipiNumberLabel = 'IPI Number'

const addPublisherSchema = z.object({
    [publisherNameKey]: z
        .string({
            error: REQUIRED_MESSAGE,
        })
        .max(200, stringSizeMaxMessage('Publisher Name', 200))
        .min(1, REQUIRED_MESSAGE),
    [ipiNumberKey]: z
        .string({
            error: REQUIRED_MESSAGE,
        })
        .max(200, stringSizeMaxMessage('IPI', 11))
        .min(1, REQUIRED_MESSAGE)
        .refine((ipiNumber) => IPIValidator(ipiNumber, false), 'Invalid IPI Number'),
})

type AddPublisherType = z.infer<typeof addPublisherSchema>

const addPublisherFormFieldsNoSchema: FormFields<AddPublisherType> = {
    [publisherNameKey]: {
        name: publisherNameKey,
        label: publisherNameLabel,
        type: FormFieldTypes.TEXT,
    },
    [ipiNumberKey]: {
        name: ipiNumberKey,
        label: ipiNumberLabel,
        type: FormFieldTypes.TEXT,
    },
}

const addAdministratorFormFieldsNoSchema: FormFields<AddPublisherType> = {
    [publisherNameKey]: {
        name: publisherNameKey,
        label: administratorNameLabel,
        type: FormFieldTypes.TEXT,
    },
    [ipiNumberKey]: {
        name: ipiNumberKey,
        label: ipiNumberLabel,
        type: FormFieldTypes.TEXT,
    },
}

const addPublisherFormFields: FormFields<AddPublisherType> = populateSchema(
    addPublisherFormFieldsNoSchema,
    addPublisherSchema
)

const addAdministratorFormFields: FormFields<AddPublisherType> = populateSchema(
    addAdministratorFormFieldsNoSchema,
    addPublisherSchema
)

export { addPublisherSchema, AddPublisherType, addPublisherFormFields, addAdministratorFormFields }
